import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { BottomTabs } from './BottomTabs';
import { SideDrawer } from '../components/SideDrawer';
import { prefetchOtcHall } from '../hooks/prefetchOtcHall';
import { prefetchGlobalTable } from '../hooks/prefetchGlobalTable';

const BOTTOM_TAB_ROUTES = new Set(['/wallet', '/trading', '/ep-hub', '/me']);

export function MobileShell() {
  const { pathname } = useLocation();
  const showBottomTabs = BOTTOM_TAB_ROUTES.has(pathname);
  const qc = useQueryClient();

  useEffect(() => {
    prefetchOtcHall(qc);
    prefetchGlobalTable(qc);
  }, [qc]);

  return (
    <div className="flex h-screen justify-center bg-black">
      {/* Mobile frame — flex column so bottom nav always stays frozen */}
      <div className="relative flex h-screen w-full max-w-[430px] flex-col bg-surface-base shadow-2xl shadow-black/60 overflow-hidden">
        {/* Global space glow */}
        <div className="pointer-events-none absolute inset-0 bg-space opacity-90" />
        <SideDrawer />
        {/* Scrollable content area — min-h-0 lets flex child shrink so overflow-y-auto actually scrolls */}
        <div className="relative min-h-0 flex-1 overflow-y-auto" data-route-scroll-container>
          <Outlet />
        </div>
        {showBottomTabs && <BottomTabs />}
      </div>
    </div>
  );
}
